import  request  from '../../Interceptor/request.js'

//水表页面获取信息
export function waterContent(data) {
    return request({
        url: '/waterBillDay/betweenTime',
        method: 'get',
        params:data
    })
}

//月查询
export function waterMonthContent(data) {
    return request({
        url: '/waterBillMonth/betweenTime',
        method: 'get',
        params:data
    })
}